import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Autocomplete } from '@mui/material';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { FormProvider, RHFAutoComplete } from '../../../components/hook-form';

// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER, NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//
import AccountPopover from './AccountPopover';

// import { RHFAutoComplete } from '../../../components/hook-form';

import useConfiguration from '../../../hooks/useConfiguration';
import { API } from '../../../utils/api';
import axios from '../../../utils/axios';
import { useClients, useSites } from 'src/api';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function ClientSelection() {
  const isMountedRef = useIsMountedRef();

  const { client, site, siteLocation, onChangeClient, onChangeSite, onChangeSiteLocation } = useConfiguration();

  // const [clients, setClients] = useState([]);
  // const [sites, setSites] = useState([]);

  const defaultValues = useMemo(() => ({ client, site }), []);

  const methods = useForm({
    defaultValues,
  });

  const {
    reset,
    watch,
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const watchSite = watch('site');
  const watchClient = watch('client');

  // const fetchClients = useCallback(async () => {
  //   await axios(API.CLIENTS.VIEW).then((response) => {
  //     if (isMountedRef.current) {
  //       setClients(response.data);
  //     }
  //   });
  // }, [isMountedRef]);

  const { data: clients = [], isLoading: clientsLoading } = useClients();
  const { data: sites = [], isLoading: sitesLoading } = useSites(watchClient?.id)

  // const fetchSites = useCallback(async () => {
  //   await axios(`${API.CLIENTS.LOCATIONS.NON_RECURSIVE}?site__client__id=${watchClient?.id}&depth=0`).then(
  //     (response) => {
  //       if (isMountedRef.current) {
  //         setSites(response.data);
  //       }
  //     }
  //   );
  // });

  useEffect(() => {
    if (watchClient?.name !== watchSite?.site?.client?.name) {
      setValue('site', null);
    }

    onChangeClient(watchClient);
    // if (watchClient) {
    //   fetchSites();
    // }
  }, [watchClient]);

  // -----------------------------------------------------------------------
  /*
  Have to have separate useEffect watching site directly as if both onChangeSite and onChangeSiteLocation
  are modified within the same useEffect as they are both async changes will overwrite each other and one of the 
  values will not be set. This forces them to occur one after the other.
  */
  useEffect(() => {
    onChangeSite(watchSite);
  }, [watchSite]);

  useEffect(() => {
    if (site?.name !== siteLocation?.site?.name) {
      onChangeSiteLocation(site, 'Browse Locations');
    }
  }, [site]);
  // -----------------------------------------------------------------------

  // useEffect(() => {
  //   fetchClients();
  // }, []);

  return (
    <FormProvider
      methods={methods}
      onSubmit={() => {
        console.log('submit');
      }}
    >
      <Stack direction="row" spacing={3}>
        <RHFAutoComplete
          name="client"
          label="Organization"
          options={clients}
          sx={{ minWidth: 200 }}
          size="small"
          getOptionLabel={(option) => option.name || ''}
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
        />
        <RHFAutoComplete
          name="site"
          label="Site"
          options={sites}
          sx={{ minWidth: 280 }}
          size="small"
          getOptionLabel={(option) => option.name || ''}
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
        />
      </Stack>
    </FormProvider>
  );
}
